import React from "react";

const StyledTableHead = ({ columns = [] }) => {
  return (
    <thead>
      <tr>
        {columns.map((col, index) => (
          <th key={index} className={`text-${col.align || "start"}`} style={{ width: col.width }}>
            <strong>{col.label}</strong>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default StyledTableHead;
